import css from './VirtualMasonryGridCellSkeleton.module.scss';

export const VirtualMasonryGridCellSkeleton = () => <div className={css.root} aria-hidden />;
